import { useFlags } from 'launchdarkly-react-client-sdk';

export const useLaunchDarklyFlag = () => useFlags();
